import libphonenumber from "google-libphonenumber";

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

export const formattedPhone = (phone: string) => {
    try {
        const number = phoneUtil.parse(phone);
        return phoneUtil.format(number, libphonenumber.PhoneNumberFormat.INTERNATIONAL);
    } catch {
        return phone;
    }
};
